<div class="d-flex flex-column">
    <app-topnav [navItems]="navItems"></app-topnav>
    <div class="d-flex">
       <app-sidenav [navItems]="navItems"></app-sidenav>
        <div class="w-100 pl-3 p-2 main-container">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
